import axios, { urlSRelease } from '..';
import { type ConfigObject, type DebugLevel, type Language } from '../../../_configs/types';
import { type Car } from '../../../_types/Car';
import checkUndefinedNullOrEmpty from '../../../utils/tools/checkUndefinedNullOrEmpty';
import checkUndefinedOrNull from '../../../utils/tools/checkUndefinedOrNull';

export default function getCar(
    idCar: Car<false>['id'],
    idFirma: ConfigObject['general']['idFirma'],
    similarCarsFiltersParam: Record<string, any>,
    currentLang: Language['value'],
    signal: AbortController['signal'],
    debug: DebugLevel
) {
    const sCarsFiltersString = [];
    const similarCarsFilters = { ...similarCarsFiltersParam };

    if (similarCarsFilters.EZ) {
        similarCarsFilters.EZVon = !checkUndefinedOrNull(similarCarsFilters.EZ[0]) ? similarCarsFilters.EZ[0] : undefined;
        similarCarsFilters.EZBis = !checkUndefinedOrNull(similarCarsFilters.EZ[1]) ? similarCarsFilters.EZ[1] : undefined;
        delete similarCarsFilters.EZ;
    }
    if (similarCarsFilters.KM) {
        similarCarsFilters.KMVon = !checkUndefinedOrNull(similarCarsFilters.KM[0]) ? similarCarsFilters.KM[0] : undefined;
        similarCarsFilters.KMBis = !checkUndefinedOrNull(similarCarsFilters.KM[1]) ? similarCarsFilters.KM[1] : undefined;
        delete similarCarsFilters.KM;
    }
    if (similarCarsFilters.Leistung) {
        similarCarsFilters.LeistungVon = !checkUndefinedOrNull(similarCarsFilters.Leistung[0]) ? Math.round(similarCarsFilters.Leistung[0]) : undefined;
        similarCarsFilters.LeistungBis = !checkUndefinedOrNull(similarCarsFilters.Leistung[1]) ? Math.round(similarCarsFilters.Leistung[1]) : undefined;
        delete similarCarsFilters.Leistung;
    }
    if (similarCarsFilters.Preis) {
        similarCarsFilters.PreisVon = !checkUndefinedOrNull(similarCarsFilters.Preis[0]) ? similarCarsFilters.Preis[0] : undefined;
        similarCarsFilters.PreisBis = !checkUndefinedOrNull(similarCarsFilters.Preis[1]) ? similarCarsFilters.Preis[1] : undefined;
        delete similarCarsFilters.Preis;
    }
    if (similarCarsFilters.Rate) {
        similarCarsFilters.rateVon = !checkUndefinedOrNull(similarCarsFilters.Rate[0]) ? similarCarsFilters.Rate[0] : undefined;
        similarCarsFilters.rateBis = !checkUndefinedOrNull(similarCarsFilters.Rate[1]) ? similarCarsFilters.Rate[1] : undefined;
        if (!checkUndefinedOrNull(similarCarsFilters.fiz)) {
            similarCarsFilters.fiz = 1;
        }
        delete similarCarsFilters.Rate;
    }
    if (similarCarsFilters.Standort) {
        similarCarsFilters.Standort = similarCarsFilters.Standort.join(',');
    }
    if (similarCarsFilters.ignoreFirma) {
        similarCarsFilters.ignoreFirma = similarCarsFilters.ignoreFirma.join(',');
    }

    similarCarsFilters.lang = currentLang?.split('-')?.[0] || 'de';

    if (similarCarsFilters.moreCars) {
        similarCarsFilters['page.page'] = similarCarsFilters.moreCars;
        similarCarsFilters['page.size'] = similarCarsFilters.pageSize;
        delete similarCarsFilters.moreCars;
    }

    for (let i = 0; i < Object.keys(similarCarsFilters).length; i++) {
        const key = Object.keys(similarCarsFilters)[i];
        const value = similarCarsFilters[key];
        if (!checkUndefinedNullOrEmpty(value) && value !== -100 && value !== '-100') {
            sCarsFiltersString.push(key + '=' + value);
        }
    }

    return axios<Car<true>>({
        debug,
        title: 'Abrufen des Fahrzeugs',
        noLogging: false,
        idFirma,
        method: 'get',
        url: `${urlSRelease}/search${idFirma === 54625 ? `/${idFirma}` : ''}/cara_${idCar}?${sCarsFiltersString?.join('&')}`,
        signal,
        validateStatus: (status) => status === 200,
    });
}
